import { useOrganization } from 'hooks';
import { useFeatureFlags } from 'utils/features';
import { isEssentialAccount } from 'utils/organizationSubscriptionStatusUtils';

export default function useIsEssentialPlan(): boolean {
  const isEssentialFlagEnabled = useFeatureFlags('ESSENTIAL');
  const { subscriptionStatus } = useOrganization();

  return isEssentialFlagEnabled || (!!subscriptionStatus && isEssentialAccount(subscriptionStatus));
}
